import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  FinancialAssetRequest,
  FinancialAssetResponse,
} from '@app/models/financial-assets.models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IFinancialAssetService } from './financial-asset.service.interface';

@Injectable({ providedIn: 'root' })
export class FinancialAssetService implements IFinancialAssetService {
  private readonly API_URL = environment.apiUrl;

  constructor(private httpClient: HttpClient) {}

  getFinancialAssets(projectId: string): Observable<FinancialAssetResponse[]> {
    return this.httpClient.get<FinancialAssetResponse[]>(
      `${this.API_URL}/FinancialAssets/${projectId}`,
    );
  }

  createFinancialAsset(
    projectId: string,
    financialAsset: FinancialAssetRequest,
  ): Observable<FinancialAssetResponse> {
    return this.httpClient.post<FinancialAssetResponse>(
      `${this.API_URL}/FinancialAsset/${projectId}`,
      financialAsset,
    );
  }

  updateFinancialAsset(
    projectId: string,
    financialAssetId: string,
    financialAsset: FinancialAssetRequest,
  ): Observable<FinancialAssetResponse> {
    return this.httpClient.put<FinancialAssetResponse>(
      `${this.API_URL}/FinancialAsset/${projectId}/${financialAssetId}`,
      financialAsset,
    );
  }

  deleteFinancialAsset(
    projectId: string,
    financialAssetId: string,
  ): Observable<FinancialAssetResponse> {
    return this.httpClient.delete<FinancialAssetResponse>(
      `${this.API_URL}/FinancialAsset/${projectId}/${financialAssetId}`,
    );
  }
}
